export const makeCsTokenHeader = (token: string) => `ClubSpark-Auth ${token}`;
